import React, { useState } from 'react';
import { PortalHeader } from './PortalHeader';
import { PortalSidebar } from './PortalSidebar';
import { AnnouncementDialog } from './AnnouncementDialog';

interface PortalLayoutProps {
  children: React.ReactNode;
}

export const PortalLayout: React.FC<PortalLayoutProps> = ({ children }) => {
  // Below lg the navigation lives in a slide-out drawer; on desktop it's in the top bar.
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="portal-container">
      <PortalHeader onToggleSidebar={() => setMobileNavOpen(!mobileNavOpen)} />

      {mobileNavOpen && (
        <div
          className="fixed inset-0 z-40 bg-ink/40 backdrop-blur-sm lg:hidden"
          onClick={() => setMobileNavOpen(false)}
          aria-hidden="true"
        />
      )}

      <PortalSidebar
        isMobileOpen={mobileNavOpen}
        onClose={() => setMobileNavOpen(false)}
      />

      <main className="portal-main">
        {children}
      </main>

      <AnnouncementDialog />
    </div>
  );
};
